import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import TermsOfServicePage from './TermsOfServicePage';
import PrivacyPolicyPage from './PrivacyPolicyPage';

// Shared modal shell for the Terms of Service / Privacy Policy content —
// mounted locally wherever it's needed (Sidebar footer, AuthModal,
// ForcePasswordChangeModal), each with its own isOpen state, rather than
// threaded through App.jsx. Deliberately not part of navItems.js/search —
// these are legal reference docs, not app features.
//
// Keeps its OWN `currentDoc` state (initialized from the `doc` prop, synced
// whenever the modal opens/its prop changes) rather than rendering `doc`
// directly — that's what lets the cross-link inside TermsOfServicePage
// ("...and our Privacy Policy") actually switch content without closing and
// reopening the modal from scratch.
export default function LegalDocModal({ isOpen, onClose, doc }) {
  const [currentDoc, setCurrentDoc] = useState(doc);
  useEffect(() => {
    if (isOpen) setCurrentDoc(doc);
  }, [isOpen, doc]);

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[400] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="relative w-full max-w-2xl max-h-[85vh] overflow-y-auto bg-slate-800 rounded-xl border border-slate-700 shadow-2xl p-6 text-slate-100">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-white transition"
        >
          <X className="w-5 h-5" />
        </button>
        {currentDoc === 'privacy' ? (
          <PrivacyPolicyPage onOpenTerms={() => setCurrentDoc('terms')} />
        ) : (
          <TermsOfServicePage onOpenPrivacy={() => setCurrentDoc('privacy')} />
        )}
      </div>
    </div>
  );
}
